import {defineStore} from "pinia";

export const usePaymentsStore = defineStore({
    id: 'projectPayments',
    state: () => ({
        payments: [],
    }),
    getters: {
        filterPayments: (state) => {
            return (name) =>
                state.payments.filter((category) => category.name === name);
        },
    },
    actions: {
        async fetchPayments(projectId) {
            // let payments  = await this.$inertia.get(`/projectPaymenst/${projectId}`);
            let payments = await fetch(`/projectPayments/${projectId}`).then((res) => res.json());
            this.payments = payments;

            console.log(payments);
            console.log(this.payments);

        }
    },
});
